import React from 'react';
import {Link} from 'gatsby';
import {Helmet} from 'react-helmet';
import Footer from './footer';
import logo from '../../img/logo.svg';
import mobileBanner from '../../img/banners/hexomatic-banner/banner-mobile.svg';
import promoText from '../../img/banners/hexomatic-banner/promo-text.svg';
import background1 from '../../img/banners/hexomatic-banner/background-1.svg';
import background2 from '../../img/banners/hexomatic-banner/background-2.svg';
import './styles.scss';

const Layout = ({children, bg, title, metaName, metaContent, small}: any) => {
  return (
    <>
      <div className="page-wrap has-text-centered">
        <section className="section p-0">
          <Helmet>
            <title>{title}</title>
            <meta name={metaName} content={metaContent} />
            <html lang="en" />
            <link rel="canonical" href={global && global.window && global.window.location.href} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaContent} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:url" content={global && global.window && global.window.location.href} />
            <meta property="og:image" content={'https://textreader.ai/Text-Reader.jpg'} />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaContent} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content={'https://textreader.ai/Text-Reader.jpg'} />
          </Helmet>
          <header>
            <div
              className={`p-0 text-center d-flex flex-wrap justify-content-center cursor-pointer`}
              style={{background: '#A500FB'}}
              id="promo-header"
              onClick={() =>
                (window.location.href = 'https://hexomatic.com/?utm_source=candidateChecker&utm_medium=hellobar')
              }
            >
              <div className="d-none d-lg-flex justify-content-center" style={{width: '100%', position: 'relative'}}>
                <img src={background1} alt="illustration1" className="illustration1" />
                <div className="d-flex justify-content-center position-relative m-auto">
                  <img src={promoText} alt="" className="m-auto" style={{maxWidth: '710px'}} />
                </div>
                <img src={background2} alt="illustration2" className="illustration2 d-none d-xl-block" />
              </div>
              <div className="d-flex d-lg-none justify-content-center" style={{width: '100%'}}>
                <div className="d-flex d-md-flex-wrap justify-content-center position-relative">
                  <img src={mobileBanner} alt="" className="px-2 mr-xl-4" style={{maxHeight: '150px'}} />
                </div>
              </div>
            </div>{' '}
            <div className="logo-container">
              <Link to="/">
                <img src={logo} alt="Text Reader" />
              </Link>
            </div>
          </header>

          <div className={`content ${small ? 'small' : ''}`}>
            {bg ? <div className={`layout-bg ${global?.window?.location?.pathname !== '/' ? 'sm' : ''}`} /> : null}
            <div className="position-relative" style={{maxWidth: '1200px', margin: 'auto'}}>
              {children}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
